import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Owner from "@/pages/Owner";
import Platform from "@/pages/Platform";
import SubscriptionGate from "@/components/SubscriptionGate";
import { Toaster } from "@/components/ui/sonner";

function Loading() {
  return (
    <div className="min-h-screen bg-[#0a0f0d] grid place-items-center text-gray-500 text-sm tracking-widest uppercase">
      Loading…
    </div>
  );
}

function homeFor(user) {
  if (user?.role === "platform") return "/platform";
  if (user?.role === "owner") return "/owner";
  return "/";
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function RoleRoute({ allow, children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (allow && user.role !== allow) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <Login />
          </PublicOnly>
        }
      />
      <Route
        path="/register"
        element={
          <PublicOnly>
            <Register />
          </PublicOnly>
        }
      />
      <Route
        path="/reset-password"
        element={<ResetPassword />}
      />
      <Route
        path="/platform"
        element={
          <RoleRoute allow="platform">
            <Platform />
          </RoleRoute>
        }
      />
      <Route
        path="/owner"
        element={
          <RoleRoute allow="owner">
            <SubscriptionGate>
              <Owner />
            </SubscriptionGate>
          </RoleRoute>
        }
      />
      <Route
        path="/"
        element={
          <RoleRoute allow="admin">
            <SubscriptionGate>
              <Dashboard />
            </SubscriptionGate>
          </RoleRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
